"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalConfirm = void 0;
var react_1 = __importStar(require("react"));
var react_dom_1 = require("react-dom");
var mixins_1 = require("../../../themes/mixins");
var useScreenWidth_1 = require("../../../utils/customHooks/useScreenWidth");
var Buttons_1 = require("../../Buttons");
var Typo_1 = require("../../Typo");
var styled_1 = require("./styled");
/**
 * @component Renders a modal confirmation component with customizable text, buttons and styling.
 *
 * - The props object containing the following properties:
 * @prop {string} title: The title to be displayed in the modal.
 * @prop {string} subTitle: The subtitle to be displayed in the modal.
 * @prop {React.ReactNode} children: The content to be rendered inside the modal.
 * @prop {() => void} onClose: A function to call when the close button is clicked.
 * @prop {string} onCloseText: The text to be displayed on the close button.
 * @prop {boolean} showConfirmBtn: A boolean indicating whether to show the confirm button.
 * @prop {boolean} showCloseBtn: A boolean indicating whether to show the close button.
 * @prop {React.MouseEventHandler<HTMLButtonElement>} onConfirm: A function to call when the confirm button is clicked.
 * @prop {string} onConfirmText: The text to be displayed on the confirm button.
 * @prop {alignActionsType} alignActions: The alignment of the action buttons.
 * @return {ReactElement} The rendered modal confirm component.
 */
var ModalConfirm = function (_a) {
    var title = _a.title, subTitle = _a.subTitle, children = _a.children, onClose = _a.onClose, _b = _a.onCloseText, onCloseText = _b === void 0 ? "Cancel" : _b, _c = _a.showConfirmBtn, showConfirmBtn = _c === void 0 ? true : _c, _d = _a.showCloseBtn, showCloseBtn = _d === void 0 ? true : _d, onConfirm = _a.onConfirm, _e = _a.onConfirmText, onConfirmText = _e === void 0 ? "Delete" : _e, _f = _a.alignActions, alignActions = _f === void 0 ? "left" : _f;
    var screenWidth = (0, useScreenWidth_1.useScreenWidth)();
    var initAnimPos = { marginTop: "100dvh", opacity: 0, translateY: "100%" };
    var endAnimPos = { marginTop: 0, opacity: 1, translateY: 0 };
    var _g = (0, react_1.useState)(endAnimPos), animPos = _g[0], setAnimPos = _g[1];
    (0, react_1.useEffect)(function () {
        document.body.style.overflow = "hidden";
        return function () { document.body.style.overflow = "unset"; };
    }, []);
    var SubTitleText = screenWidth >= (0, mixins_1.getBreakPoint)('sm') ? Typo_1.SANS_4 : Typo_1.SANS_3;
    var genModalContents = function () { return (react_1.default.createElement(react_1.Fragment, null,
        onClose && (react_1.default.createElement(styled_1.StyledModalConfirmClose, null,
            react_1.default.createElement(Buttons_1.ButtonPrimary, { S: true, icon: "X", onClick: function () { return setAnimPos(initAnimPos); } }))),
        react_1.default.createElement(styled_1.StyledModalConfirmContent, null,
            title && (react_1.default.createElement("div", null,
                react_1.default.createElement(Typo_1.SERIF_5_6, null, title))),
            subTitle && (react_1.default.createElement(styled_1.StyledModalConfirmContentSubtitle, null,
                react_1.default.createElement(SubTitleText, null, subTitle))),
            react_1.default.createElement("div", { style: { marginTop: (title || subTitle) && "2rem" } }, children ? children : null),
            react_1.default.createElement(styled_1.StyledFlexWrapper, { style: { marginTop: (children) && "2rem" }, alignActions: alignActions },
                showConfirmBtn && react_1.default.createElement(Buttons_1.ButtonPrimary, { onClick: onConfirm }, onConfirmText),
                showCloseBtn && react_1.default.createElement(Buttons_1.ButtonSecondary, { onClick: onClose }, onCloseText))))); };
    return ((0, react_dom_1.createPortal)(react_1.default.createElement(styled_1.StyledModalConfirm, { initial: { opacity: initAnimPos.opacity }, animate: { opacity: animPos.opacity }, transition: { type: "tween", ease: "easeOut" }, onClick: function () { return onClose(); } }, screenWidth < (0, mixins_1.getBreakPoint)("sm") ? (react_1.default.createElement(styled_1.StyledModalConfirmContentWrapper, { initial: { marginTop: initAnimPos.marginTop, translateY: initAnimPos.translateY }, animate: { marginTop: animPos.marginTop, translateY: animPos.translateY }, transition: {
            type: "tween",
            ease: "easeOut",
        }, onAnimationComplete: function () {
            if (animPos.marginTop === initAnimPos.marginTop)
                onClose();
        }, onClick: function (e) { return e.stopPropagation(); } }, genModalContents())) : (react_1.default.createElement(styled_1.StyledModalConfirmContentWrapper, { initial: {
            opacity: initAnimPos.opacity,
            marginTop: initAnimPos.marginTop,
        }, animate: {
            opacity: animPos.opacity,
            marginTop: animPos.marginTop,
        }, transition: {
            type: "tween",
            ease: "easeOut",
        }, onAnimationComplete: function () {
            if (animPos.marginTop === initAnimPos.marginTop)
                onClose();
        }, onClick: function (e) { return e.stopPropagation(); } }, genModalContents()))), document.getElementById("modal-root")));
};
exports.ModalConfirm = ModalConfirm;
